import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Supplier } from "@/v2/types";

export type SupplierOption = Pick<Supplier, "id" | "full_name" | "short_code">;

// Lists all approved suppliers (id, name, short code) for mobilization filters,
// regardless of the user's supplier assignment.
export default async function FindAllMobilizationSupplierOptions({
    limit,
    skip,
    search,
}: {
    skip?: number;
    limit?: number;
    search?: string;
}): Promise<{ data: SupplierOption[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/mobilizations/supplier-options",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
        },
    });

    return res.data;
}
